import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=40aa318d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=40aa318d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa318d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40aa318d')) {
      api.createRecord('40aa318d', component.options)
    } else {
      api.reload('40aa318d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=40aa318d&scoped=true&", function () {
      api.rerender('40aa318d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Uvb14RvYWP8G/JS/comp/GuestBox.vue"
export default component.exports